<template>
    <div class="loading"></div>
</template>

<script>
export default {
    name: 'loading'
}
</script>

<style scoped>
.loading {
  position: absolute;
  white-space: nowrap;
  background: url('/images/spinner.gif') center center no-repeat;
  background-size:60px 60px;
  width: 900px;
  height: 416px;
  z-index: 50;
}

.loading-enter,
.loading-leave-active {
  opacity: 0;
}
.loading-enter-active,
.loading-leave-active
{
  transition: opacity .75s ,height .75s;
}

</style>